module.exports = __webpack_public_path__ + "static/media/donnellycivilengineering.e8889433.png";